export default {"src":"/_next/static/media/medias.0bb934ac.svg","height":29,"width":265,"blurWidth":0,"blurHeight":0};